import type {
  IInvestorAnalysisAnswersSchemaV1,
  IInvestorAnalysisUnsophisticatedAnswersV1,
} from '~/@api/generated-api-types-user/Api'
import { type AllStepsData as SophisticatedData } from './analysis-form-sophisticated/steps'
import { type AllStepsData as UnsophisticatedData } from './analysis-form-unsophisticated/steps/AllStepsData'

// Do API idú len zvolené odpovede; texty otázok a body dopĺňa API z definície verzie.

type InstrumentKey = NonNullable<
  IInvestorAnalysisUnsophisticatedAnswersV1['investmentInstruments']
>[number]

function buildUnsophisticatedAnswers(
  data: UnsophisticatedData
): IInvestorAnalysisUnsophisticatedAnswersV1 {
  const base = {
    investmentExperience: data.investmentExperience.value,
    financialStability: data.financialStability.value,
    riskAttitude: data.riskAttitude.value,
    investmentGoal: data.investmentGoal.value,
    investmentDuration: data.investmentDuration.value,
    educationLevel: data.educationLevel.value,
    annualNetIncome: data.annualNetIncome,
    assetsValue: data.assetsValue,
    annualCommitmentsAmount: data.annualCommitmentsAmount,
  }

  // začiatočník otázky o skúsenostiach nedostane, API ich pri ňom odmietne
  if (data.investmentExperience.value === 'novice') return base

  return {
    ...base,
    investmentInstruments: Object.entries(data.investmentInstruments)
      .filter(([, instrument]) => instrument?.checked)
      .map(([key]) => key as InstrumentKey),
    collectiveFinancingResults: data.collectiveFinancingResults.value,
    pastInvestmentAmount: data.pastInvestmentAmount.value,
    investmentFrequency: data.investmentFrequency.value,
  }
}

export function buildAnswers(params: {
  isSophisticatedInvestor: boolean | null
  sophisticatedTestData: SophisticatedData | null
  unsophisticatedTestData: UnsophisticatedData | null
}): IInvestorAnalysisAnswersSchemaV1 {
  const sophisticated = params.sophisticatedTestData

  return {
    // staršie rozpracované dotazníky odpoveď v store nemajú (undefined)
    initial: params.isSophisticatedInvestor ?? null,
    sophisticated: sophisticated && {
      highIncomeOrLargePortfolio: sophisticated.highIncomeOrLargePortfolio,
      experiencedInFinanceOrExecutiveRole:
        sophisticated.experiencedInFinanceOrExecutiveRole,
      experienceInLargeCompanies: sophisticated.experienceInLargeCompanies,
      averaged10LargeTransactionsQuarterlyLastYear:
        sophisticated.averaged10LargeTransactionsQuarterlyLastYear,
    },
    unsophisticated:
      params.unsophisticatedTestData &&
      buildUnsophisticatedAnswers(params.unsophisticatedTestData),
  }
}
